<template>
    <section>
        <div class="container container--fluid">
            <v-card>
                    <v-card-title class="headline">
                        {{$t('sent_faxes_list')}}
                        <v-spacer></v-spacer>
                        <v-btn
                                small
                                v-if="false"
                                color="primary"
                                class="white--text"
                                @click="dialog = true"
                        >
                            {{$t('send_fax')}}
                            <v-icon right dark>mdi-send</v-icon>
                        </v-btn>
                        <v-btn
                            icon
                            small
                            @click="fetch()"
                        >
                            <v-icon right dark>mdi-reload</v-icon>
                        </v-btn>
                    </v-card-title>
                    <v-card-subtitle>{{$t('sent_fax_list_subtitle')}}</v-card-subtitle>
                    <v-divider></v-divider>
                    <v-data-table
                            class="text-capitalize"
                            :headers="headers"
                            :items="items"
                            :loading="loading"
                            :options.sync="options"
                            :server-items-length="total"
                            :page="options.page"
                            :items-per-page="options.itemsPerPage"
                            :footer-props="footerProps"
                    >
                        <template v-slot:top>
                            <v-select
                                    clearable
                                    v-model="displayMode"
                                    label="نمایش"
                                    :items="[{ key : 'NormalFax', value : 'ارسال عادی'},{ key : 'BroadcastFax', value : 'ارسال انبوه'}]"
                                    item-text="value"
                                    item-value="key"
                                    class="mx-4 pa-1"
                            ></v-select>
                        </template>
                        <template #item.to="{item}">
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <router-link
                                            :to="{name : 'FaxesList', query : { filters : [{column_name : 'to', operand : 'IsEqualTo', value : item.to}]}}"
                                            color="red"
                                            text-color="white"
                                            v-bind="attrs"
                                            v-on="on"
                                    >{{item.to}}</router-link>
                                </template>
                                <span>{{$t('fax_filtered_by_to')}}</span>
                            </v-tooltip>
                            <v-chip
                                    v-if="item.to_vertical_service_code"
                                    color="info"
                                    small
                                    class="ma-2"
                                    text-color="white"
                            >
                                {{$t('to_vertical_service_code' , {
                                to_vertical_service_code : item.to_vertical_service_code
                                })}}
                            </v-chip>

                            <CopyToClipboard :text="item.to"/>
                        </template>
                        <template #item.user_id="{item}">
                            <transition name="fade" mode="out-in">
                                <router-link
                                        :to="{name : 'FaxesList', query : { filters : [{column_name : 'user_id', operand : 'IsEqualTo', value : item.user_id}]}}"
                                        color="red"
                                        text-color="white"
                                >
                                    {{ item.user_fullname}} {{(item.user_mobile)}}
                                </router-link>
                            </transition>
                        </template>
                        <template #item.status="{item}">
                            <v-chip
                                    small
                                    class="ma-2"
                                    :color="getStatusColor(item)"
                                    text-color="white"
                            >
                                {{$t("fax_status")[item.status]}}
                            </v-chip>
                            <v-chip
                                    v-if="item.fax_broadcast_id"
                                    small
                                    class="ma-2"
                            >
                                فکس انبوه
                            </v-chip>
                        </template>
                        <template #item.attempts="{item}">
                            {{ $t('messages.attempts',{ attempts : item.attempts, tries : item.tries}) }}
                        </template>
                        <template #item.created_at="{item}">
                            {{ getJalaliDate(item.created_at * 1000) }}
                        </template>
                        <template #item.completed_at="{item}">
                            <span v-if="item.completed_at">
                                {{ getJalaliDate(item.completed_at * 1000) }}
                            </span>
                            <v-chip
                                    v-else
                                    small
                                    class="ma-2"
                                    text-color="white"
                            >
                                {{$t('undefined')}}
                            </v-chip>
                        </template>
                        <template #item.fax_channel_id="{item}">
                            <transition name="fade" mode="out-in">
                                <v-chip
                                        v-if="!item.fax_channel_id"
                                        color="error"
                                        x-small
                                > -- </v-chip>

                                <v-skeleton-loader
                                        v-else-if="fetchingFaxChannels"
                                        type="text"
                                        class="mt-2"
                                ></v-skeleton-loader>

                                <div v-else>
                                    <v-tooltip top color="info" v-if="faxChannels[item.fax_channel_id].description">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon
                                                    v-bind="attrs" v-on="on"
                                                    color="info"
                                            >mdi-information-outline</v-icon>
                                        </template>
                                        <span>{{faxChannels[item.fax_channel_id].description}}</span>
                                    </v-tooltip>
                                    {{ faxChannels[item.fax_channel_id].name }}
                                </div>
                            </transition>
                        </template>
                        <template #item.actions="{item}">
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon small :loading="downloadFileLoading.indexOf(item.id) > -1" @click="downloadFile(item)" v-bind="attrs" v-on="on">
                                        <v-icon>mdi-cloud-download-outline</v-icon>
                                    </v-btn>
                                </template>
                                <span>{{$t('download_fax_file')}}</span>
                            </v-tooltip>
                            <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                    <router-link
                                            :to="{ name: 'Logs', query: { filters: [{ value: item.id, operand: 'IsEqualTo', column_name : 'fax_id' }], orders: [{ 'column_name' : 'id', 'value' : 'desc' }] } }"
                                            class="no-decoration"
                                    >
                                        <v-icon
                                                v-bind="attrs"
                                                v-on="on"
                                        >mdi-math-log</v-icon>
                                    </router-link>

                                </template>
                                <span>{{$t('logs')}}</span>
                            </v-tooltip>
                            <v-btn small text color="info" @click="showFax = item">
                                <v-icon left>
                                    mdi-eye
                                </v-icon>
                                نمایش جزییات
                            </v-btn>
                        </template>
                    </v-data-table>

                    <v-dialog v-model="dialog" :loading="formLoading" @close="dialog = false" max-width="500px">
                    </v-dialog>
                </v-card>
        </div>
        <FaxDetails
                v-if="showFax"
                :fax="showFax"
                @close="showFax = null"
        ></FaxDetails>
    </section>
</template>

<script>
    import { mapState, mapActions, mapGetters } from 'vuex';

    import RequestList from "../services/RequestList";
    import Service from "../services/FaxesService";
    import StorageService from "../services/StorageService";
    import CopyToClipboard from '@/components/CopyToClipboard'
    import FaxDetails from '../components/FaxDetails'
    import CRUDMixin from '../mixins/CRUDMixin'

    export default {
        mixins : [CRUDMixin],
        components : {
            CopyToClipboard,
            FaxDetails
        },
        computed: {
            ...mapState({
                usersKeyedById: state => state.users.users,
                users : state => state.users.items
            }),
            ...mapGetters({
                fetchingUsers: 'users/fetching',
                faxChannels: 'faxChannels/keyedById',
                fetchingFaxChannels: 'faxChannels/fetching',
            })
        },
        mounted() {
            if(Object.keys(this.faxChannels).length <= 0){
                this.syncFaxChannels();
            }
        },
        watch: {
            dialog (val) {
                !val && this.close()
            },
            displayMode(value){
                this.$router.push({
                    query : {
                        filters: [
                            {operand: value === 'NormalFax' ? 'IsNull' : 'IsNotNull', column_name: 'fax_broadcast_id'}
                        ],
                        orders: [
                            {'column_name': 'id', 'value': 'desc'}
                        ]
                    }
                }).catch(err => err);
            }
        },
        data() {
            return {
                displayMode : 'NormalFax',
                showFax : null,
                dialog : false,
                search : null,
                loading : false,
                formLoading : false,
                downloadFileLoading : [],
                headers : [
                    {
                        text: this.$t('to'),
                        value: 'to',
                    },
                    {
                        text: this.$t('user'),
                        value: 'user_id',
                    },
                    {
                        text: this.$t('status'),
                        value: 'status',
                    },
                    {
                        text: this.$t('attempts'),
                        value: 'attempts',
                    },
                    {
                        text: this.$t('number_of_pages'),
                        value: 'number_of_pages',
                    },
                    {
                        text: this.$t('fax_channel'),
                        value: 'fax_channel_id',
                    },
                    {
                        text: this.$t('created_at'),
                        value: 'created_at',
                    },
                    {
                        text: this.$t('completed_at'),
                        value: 'completed_at',
                    },
                    {
                        text: this.$t('action'),
                        value: 'actions',
                    }
                ],
                items : []
            }
        },

        methods: {
            ...mapActions({
                syncFaxChannels: 'faxChannels/sync'
            }),
            async fetch() {
                this.loading = true;

                let page = this.$route.query.page || 1;
                let count = this.$route.query.count || this.options.itemsPerPage;

                let requestList = new RequestList();

                requestList.setFilters(this.$route.query.filters || []);
                requestList.addOrder('id','desc');
                requestList.setPage(page, count);

                requestList.addFilter('type', 'IsEqualTo', 'outgoing');

                try {
                    let {data} = await Service.list(requestList);
                    this.items = data.value.faxes;
                    this.total = data.value.total;
                } finally {
                    this.loading = false;
                }
            },
            getStatusColor(fax){
                let color = null;
                switch (fax.status){
                    case 'waiting_to_send' :
                        color = 'warning';
                        break;
                    case 'sending' :
                        color = null;
                        break;
                    case 'failed' :
                        color = 'error';
                        break;
                    case 'canceled' :
                        color = 'secondary';
                        break;
                    case 'completed' :
                        color = 'success';
                        break;
                }
                return color;
            },
            faxCreated(){
                this.dialog = false;
                this.fetch();
            },
            async downloadFile(fax){
                this.downloadFileLoading.push(fax.id);

                let request = new RequestList();
                request.addFilter('id','IsEqualTo', fax.file_id);

                let {data} = await StorageService.list(request);

                this.downloadFileLoading.splice(this.downloadFileLoading.indexOf(fax.id), 1);

                let link = document.createElement("a");
                // If you don't know the name or want to use
                // the webserver default set name = ''
                link.href = data.value.files.pop().url;
                link.target = '_blank';
                link.style.display = 'none';
                document.body.appendChild(link);
                link.click();
                link.remove();

            }

        }
    }
</script>